import React, { useMemo } from 'react';
import SVG from 'react-inlinesvg';

import InlineSvgs from '@tb-core/components/composites/inline-svgs';
import { s3AssetPath } from '@tb-core/helpers/contentful/s3-asset-path';
import usePageContext from '@tb-core/hooks/use-page-context';

interface TopBodyProps {
    inlineSvgs?: string[];
}

const TopBody = ({ inlineSvgs }: TopBodyProps) => {
    const {
        content: { pageData },
        publicEnv: { assetPath }
    } = usePageContext();
    const icons = pageData.layout.icons;

    return useMemo(() => {
        return (
            <InlineSvgs icons={icons}>
                {inlineSvgs?.map((svg, i) => (
                    <SVG
                        key={i}
                        src={
                            assetPath + s3AssetPath('/_static/web/icons/', svg)
                        }
                        uniquifyIDs={false}
                    />
                ))}
            </InlineSvgs>
        );
    }, [assetPath]);
};

export default TopBody;
